import { Route } from 'vue-router';
import Vue from 'vue';
import _ from '../utils';
import { Guard } from '../plugins/guards/guardWrapper';

export default {
  name: 'TranslationGuard',
  async appLoad() {
    if (Vue.$version.buildConfiguration === 'test') {
      return;
    }
    if (Vue.$config.values['language-translations-path']) {
      const base = `${Vue.$appConfigPath}/`;
      const configUrl = base + Vue.$config.values['language-translations-path'];
      const response = await Vue.$fetch.get(configUrl, { baseURL: '' });
      Vue.$log.info(`💬 [TRANSLATOR] Loaded translations from ${configUrl}`);
      Vue.$translation.loadTranslationMaps(response.data as any);
    }
    const currentLanguage = Vue.$translation.get();
    if (!_.isSet(currentLanguage)) {
      Vue.$translation.set(Vue.$config.values['language-default']);
    }
  },
  routeBeforeEnter(to: Route, from: Route) {
    if (to.query) {
      const queries = Vue.$routerUtils.getQueryParams();
      const languageQuery = queries.language;
      if (languageQuery) {
        Vue.$translation.set(languageQuery as string);
      }
    }
  },
} as Guard;
